import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'avn/services/api.service';

@Component({
  selector: 'app-category-faq',
  templateUrl: './category-faq.component.html',
  styleUrls: ['./category-faq.component.scss']
})
export class CategoryFaqComponent implements OnInit {
  set1: any[] = [];
  set2: any[] = [];

  @Input() category = '';
  @Input() suburb = '';

  constructor(
    private route: ActivatedRoute,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.getCategoryFAQ();
  }
  getCategoryFAQ() {
    const text = this.category + '' + (this.suburb ? '-' + this.suburb : '');
    const responseObs = this.api.getCategoryFAQ(text);
    responseObs.subscribe((response: any) => {
      if (response.length > 0) {
        this.parseFAQ(response[0].content.rendered);
      }
    });
  }

  parseFAQ(content: any) {
    const faqs: any = [];
    const container = document.createElement('div');
    container.innerHTML = content;
    let quesList = container.getElementsByTagName('h3');
    if (!quesList) {
      quesList = container.getElementsByTagName('h2');
    }

    let current_question = 0;

    for (let index = 0; index < container.children.length; index++) {
      if (container.children[index].tagName.toLowerCase() === 'h3') {
        current_question = faqs.length;
        faqs.push({ ques: container.children[index].textContent, response: [] });
      } else {
        try {
          faqs[current_question].response.push(container.children[index].innerHTML);
        } catch (error) {
          console.info(error);
        }
      }
    }

    const midpoint = Math.ceil(faqs.length / 2);
    this.set1 = faqs.slice(0, midpoint);
    this.set2 = faqs.slice(midpoint);
  }

  htmlDecode(input: any) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }
}
